(function () {
  var selector = '[data-eoo-color-scroller]';

  function setup(root) {
    var track = root.querySelector('[data-eoo-color-track]');
    var prev = root.querySelector('[data-eoo-color-prev]');
    var next = root.querySelector('[data-eoo-color-next]');
    if (!track || !prev || !next) return;

    function update() {
      var max = Math.max(0, track.scrollWidth - track.clientWidth);
      var overflow = max > 4;
      root.classList.toggle('is-overflow', overflow);
      var start = track.scrollLeft <= 2;
      var end = track.scrollLeft >= max - 2;
      root.classList.toggle('is-start', start);
      root.classList.toggle('is-end', end);
      prev.disabled = !overflow || start;
      next.disabled = !overflow || end;
      prev.setAttribute('aria-hidden', overflow ? 'false' : 'true');
      next.setAttribute('aria-hidden', overflow ? 'false' : 'true');
    }

    function scrollByDir(dir) {
      track.scrollBy({ left: dir * Math.max(120, track.clientWidth * 0.7), behavior: 'smooth' });
    }

    prev.addEventListener('click', function (event) {
      event.preventDefault();
      scrollByDir(-1);
    });
    next.addEventListener('click', function (event) {
      event.preventDefault();
      scrollByDir(1);
    });
    track.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);

    if (typeof ResizeObserver === 'function') {
      new ResizeObserver(update).observe(track);
    }

    update();
  }

  function init(scope) {
    var wrap = scope && scope.querySelectorAll ? scope : document;
    wrap.querySelectorAll(selector).forEach(function (root) {
      if (root.dataset.eooColorReady === 'true') return;
      root.dataset.eooColorReady = 'true';
      setup(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init(document);
    });
  } else {
    init(document);
  }
  document.addEventListener('page:loaded', function () {
    init(document);
  });
  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();
